import PlanProposal from '@/shared/models/PlanProposal'

import priceCalculator from '@/shared/services/usePriceCalculator'
import {
    createProposalModule,
    findModuleIndex,
} from '@/shared/utils/moduleUtils'

/**
 * Cria um objeto PlanProposal inicializado com a estrutura padrão de proposta.
 */
export function createInitialPlanProposal() {
    const planProposal = new PlanProposal()
    planProposal.proposal = {
        loyalty: false,
        modules: [],
        discount: 0,
        renovation: true,
        final_price: 0,
        total_price: 0,
        proportional: true,
        configuration: true,
    }

    return planProposal
}

/**
 * Adiciona ou substitui um módulo na proposta, garantindo 1 registro por module_id.
 */
export function addOrReplaceModuleInProposal(planProposal, module) {
    if (!planProposal || !planProposal.proposal) {
        return
    }

    const proposalModule = createProposalModule(module)

    const existingModuleIndex = findModuleIndex(
        planProposal.proposal.modules,
        proposalModule.module_id,
    )

    if (existingModuleIndex === -1) {
        planProposal.proposal.modules.push(proposalModule)
    } else {
        planProposal.proposal.modules.splice(
            existingModuleIndex,
            1,
            proposalModule,
        )
    }
}

/**
 * Recalcula total, desconto e valor final da proposta.
 */
export function recalculateProposalPrices(planProposal, discountCode) {
    if (!planProposal || !planProposal.planPackage) return

    const totalPrice = priceCalculator.calculateTotalPrice(
        planProposal.planPackage,
        planProposal.proposal.modules,
    )

    planProposal.total_price = totalPrice
    planProposal.proposal.total_price = totalPrice

    const discount = priceCalculator.calculateDiscount(
        planProposal.total_price,
        planProposal.planPackage,
        planProposal.proposal.loyalty,
        discountCode,
    )

    planProposal.proposal.discount = discount

    const finalPrice = priceCalculator.calculateFinalPrice(
        planProposal.total_price,
        discount,
    )

    planProposal.proposal.final_price = finalPrice
    planProposal.final_price = finalPrice
}

/**
 * Sincroniza um módulo de app/terceiro com a proposta (add/remove/atualiza).
 */
export function syncAppModuleWithProposal(planProposal, module) {
    if (!planProposal || !planProposal.proposal) {
        return
    }

    const normalized = createProposalModule(module)
    if (!normalized) {
        return
    }

    const shouldInclude =
        normalized.price_type === 'per_unit'
            ? normalized.add_amount > 0
            : !!normalized.checked

    const existingModuleIndex = findModuleIndex(
        planProposal.proposal.modules,
        normalized.module_id,
    )

    if (shouldInclude) {
        normalized.checked = true

        if (existingModuleIndex === -1) {
            planProposal.proposal.modules.push(normalized)
        } else {
            const target = planProposal.proposal.modules[existingModuleIndex]

            target.amount =
                normalized.add_amount != null
                    ? normalized.amount + normalized.add_amount
                    : normalized.amount
            target.add_amount = normalized.add_amount
            target.checked = true
            target.price = normalized.price
            target.price_type = normalized.price_type
        }
    } else if (existingModuleIndex !== -1) {
        planProposal.proposal.modules.splice(existingModuleIndex, 1)
    }

    // Importante: não chamamos recálculo aqui; o caller decide quando recalcular.
}
